<template>
    <div class="activityPage" :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
        <page-navigate></page-navigate>
        <div id="app" v-cloak>
            <div class="activityListHead">
                <div class="contentBox flex justify-between items-center">
                    <div class="activityHeadContent active" v-for="(item, index) in headerContent">
                        <h1 class="title-48_bold md-title-24_bold" v-html="item.title"></h1>
                        <h2 class="activityHeadContentDesc subtitle-20_regular md-content-14_regular">{{ item.desc }}</h2>
                        <a :href="item.src" :target="item.ifTarget ? '_blank' : ''"
                            class="primary-default_large activityHeadBtn">
                            <span>{{ item.btn }}</span>
                            <span class="iconfont icon-right"></span>
                        </a>
                    </div>

                    <div class="swiper activityModelSwiper">
                        <div class="swiper-wrapper">
                            <img v-for="(item, index) in headerContent" :src="item.bannerSrc" alt=""
                                class="activityModel swiper-slide">
                        </div>
                    </div>
                </div>
                <div class="hoverPagenation flex" v-if="headerContent.length > 1">
                    <div class="icon-left cursor-pointer" @click="shiftSwiper(-1)">
                        <img src="/ebc-static/image/activityList/icon-left.png" alt="">
                    </div>
                    <div class="icon-right cursor-pointer" @click="shiftSwiper(1)">
                        <img src="/ebc-static/image/activityList/icon-left.png" alt="">
                    </div>
                </div>
                <div class="mobilePagenation justify-center items-center">
                    <div v-for="item in headerContent.length"></div>
                </div>
            </div>
            <div class="activityListContainer">
                <div class="contentBox">

                    <div class="activityListFilter flex justify-between items-center ">
                        <div class="activityListTab flex items-center justify-start">
                            <div class="body-16_regular md-content-14_regular cursor-pointer"
                                v-for="(item, index) in activityListTab" :class="{ active: activityListTabAct == index }"
                                @click="e => changeTab(index, e)">{{ item }}</div>
                        </div>
                        <div class="activity-dropdown-container" ref="dropdownRef">
                            <div class="activity-dropdown-trigger" :class="{ 'activity-active': isOpen }"
                                @click="toggleDropdown">
                                <span>{{ selectedLabel }}</span>
                                <span class="activity-arrow">▼</span>
                            </div>

                            <div class="activity-dropdown-menu" v-if="isOpen">
                                <div class="activity-dropdown-item" v-for="(item, index) in dropdownOptions"
                                    :key="item.value" :class="{ 'activity-selected': currentVal === item.value }"
                                    @click="handleSelect(item, index)">
                                    {{ item.label }}
                                </div>
                            </div>
                        </div>
                        <div class="mobile scrollTabWrapper">
                            <div class="scrollTab flex items-center">
                                <div class="tabItem text-center cursor-pointer md-footnote-regular_12"
                                    v-for="(item, index) in dropdownOptions" ::key="item.label"
                                    :class="{ active: scrollTabAct == index }"
                                    @click="e => initMobileTabWrapper(index, item, e)">
                                    {{ item.label }}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="activityListData flex items-center justify-between flex-wrap" v-cloak>
                        <div class="activityListCard cursor-pointer" v-for="(item, index) in dataMeta" :key="index"
                            @click="jumpToActivity(item)">
                             <div class="activityListCardImg">
                              <img :src="item.img" alt="">
                            </div>
                            <div class="activityContent">
                                <div class="footnote-regular_12 activityStatus  flex items-center justify-center"
                                    :class="{ end: item.status == 'ended', hot: item.status == 'processing', wait: item.status == 'pending' }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                        fill="none" v-if="item.status == 'processing'">
                                        <path
                                            d="M13.1047 9.45026C11.3673 5.64572 12.4881 4.42487 12.4994 4.41256C12.519 4.39286 12.5216 4.36162 12.5066 4.33687C12.4906 4.31354 12.4611 4.30489 12.4346 4.31576C12.4095 4.32524 9.99138 5.34385 10.2957 7.60173C9.63182 6.99964 6.53377 3.90628 8.42908 0.270506C8.44074 0.247225 8.43712 0.219564 8.4196 0.201384C8.40283 0.182501 8.37555 0.176713 8.35339 0.186163C8.31231 0.202871 7.34554 0.621084 6.57547 1.6768C5.86476 2.64829 5.2034 4.36733 6.09372 7.02783C6.41769 8.28011 5.80688 9.29439 5.47972 9.72491C5.56008 9.42823 5.66149 8.92509 5.64471 8.34765C5.61854 7.50264 5.31671 6.33494 4.02821 5.58015C4.00856 5.56858 3.9828 5.56917 3.96349 5.58305C3.94395 5.5991 3.93515 5.62228 3.94094 5.64635C3.94535 5.66888 4.42741 7.89185 3.58179 8.92003C2.85169 9.80783 2.13687 11.3522 2.52374 12.7826C2.84842 13.9788 3.8617 14.8927 5.53634 15.4963C5.96614 15.6294 6.37662 15.7313 6.831 15.817C6.86007 15.8236 6.88952 15.8055 6.89825 15.777C6.90698 15.7465 6.89316 15.7152 6.86589 15.7022C6.00565 15.3255 5.11854 14.5401 5.77773 12.9455C6.40561 11.5704 6.29325 10.8622 6.16708 10.5583C6.49174 10.7429 7.13633 11.2229 6.97525 12.0656C6.97124 12.0897 6.98176 12.1158 7.00355 12.1281C7.02538 12.142 7.05194 12.1405 7.07154 12.1237C7.09197 12.1078 9.02986 10.4966 8.1489 8.52222C8.58293 8.7753 9.73372 9.65952 9.05528 11.6911C8.82905 12.5637 9.44457 13.192 9.47034 13.2189C9.49078 13.2385 9.52167 13.2422 9.5453 13.2262C9.56817 13.2116 9.57763 13.1811 9.56786 13.1542C9.54791 13.0996 9.08865 11.8496 10.0849 11.1589C10.0318 11.4803 9.94853 12.2736 10.3052 12.7063C10.6247 13.0968 10.9346 13.7352 10.84 14.3592C10.7735 14.7976 10.5172 15.1685 10.0744 15.4579C10.0489 15.4761 10.0398 15.5074 10.0529 15.535C10.0653 15.5626 10.0969 15.575 10.1252 15.5662C11.2188 15.2004 12.6528 14.474 13.2774 13.0888C13.7395 12.0687 13.6814 10.8449 13.1047 9.45026Z"
                                            fill="#A52933" />
                                    </svg>
                                    {{ activityContentStatus[item.status] }}
                                </div>
                                <div class="activityTitle  subtitle-18_medium md-body-16_medium" v-html="item.title">
                                </div>
                                <div class="activityBtn flex items-center justify-center">
                                    <span class="body-14_medium">{{ item.btnWord || '了解更多' }}</span>
                                    <span class="iconfont icon-right"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pageNavigation flex justify-center items-center" v-cloak v-if="pageNavigationNumber > 1">
                        <span class="iconfont icon-a-down" :class="{ notAllow: targetNavigationIndex == 1 }"
                            style="transform: rotate(90deg)"
                            @click="targetNavigationIndex = targetNavigationIndex - 1"></span>
                        <div v-for="item in visiblePages" class="body-16_regular cursor-pointer"
                            :class="targetNavigationIndex == item ? 'active' : ''" @click="setTargetNavigationIndex(item)">
                            {{ item == 0 ? '...' : item }}</div>
                        <span class="iconfont icon-a-down"
                            :class="{ notAllow: targetNavigationIndex == pageNavigationNumber }"
                            style="transform: rotate(-90deg)"
                            @click="targetNavigationIndex = targetNavigationIndex + 1"></span>
                    </div>
                </div>
            </div>
        </div>
        <page-footer></page-footer>
    </div>
</template>
<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
const activityListMetaData= [
    {
      label: "市场活动",
      list: [
        {
          id: "2-12",
          img: require("@/assets/image/activityList/banner2_12.png?v=2.0.0"),
          bannerTitle: `<img
          class="img-logo"
          src="${require("@/assets/image/logo/logo_row_white.svg")}"
          alt="logo"
        />
        <div class="barca2526-title">交易赢巴萨球票<br/> 亲临<span>巴萨</span>25/26赛季主场</div>
        <img
          class="img-arrow"
          src="${require("@/assets/image/activityList/arrow.svg")}"
          alt=""
        />
        `,
          bannerBoxClass: "barca2526-title-box",
          bannerSubTitle: "",
          title: "交易赢巴萨球票 亲临巴萨25/26赛季主场",
          subtitle:
            "在全球最佳券商EBC交易，即可赢取巴塞罗那足球俱乐部主场球票，机票、酒店全程礼遇，见证红蓝军团在绿茵场上的精彩演绎。",
          url: "/activityList/barca2526",
          time: "",
        },
        {
          id: "2-6",
          img: require("@/assets/image/activityList/Mid-AutumnFestival.png"),
          title: "EBC中秋双重好礼",
          subtitle:
            "首存即赠EBC 588元定制礼盒，累计交易还可赢取茅台、iPhone17 等豪礼。月圆共盈，与EBC同行享圆满！",
          url: "/activityList/Mid-AutumnFestival",
          time: "",
        },
        {
          id: "2-4",
          img: require("@/assets/image/activityList/banner2_4New.jpg"),
          bannerTitle: "加入基金经理成长计划",
          bannerSubTitle: '赚取<span class="red">18%</span>年化管理费',
          title: "基金经理成长计划",
          subtitle:
            "这是一项专为优秀交易者打造的资产增值计划！根据交易员的管理资金量发放月度奖金，奖金比例高达年化18%！",
          url: "/pay",
          time: "",
        },
        {
          id: "2-3",
          img: require("@/assets/image/activityList/banner2_3.jpg"),
          bannerTitle: "创作即收益<br/>月月现金到账",
          bannerTitleClass: "creator-incentives-title",
          bannerSubTitle: "",
          bannerSubTitleClass: "creator-incentives-subtitle",
          title: "创作者激励计划",
          subtitle: "加入EBC创作者激励计划，轻松变现影响力",
          url: "/activityList/creator-incentives",
          time: "",
          btnWord:'成为创作者',
        },
        
        // {
        //   id: "2-10",
        //   img: require("@/assets/image/activityList/messi.png"),
        //   title: "在EBC交易赢梅西签名限量球衣",
        //   subtitle: "活动时间：2025年3月1日 - 2025年3月31日",
        //   url: "/trade-for-messi",
        //   time: "",
        // },
        {
          id: "2-7",
          img: require("@/assets/image/activityList/banner2_7.jpg"),
          title: "EBC携手Trading view连接全球资源",
          subtitle: "限时领Trading view会员权益 全球市场动态即时掌控",
          url: "/TradingView",
          time: "",
        },

        {
          id: "2-5",
          img: require("@/assets/image/activityList/banner2_5.png"),
          title: "免费领取订单流",
          subtitle: "助您夺回交易世界的主动权",
          url: "/orderflow/",
          time: "",
        },
        
      ],
    },
    {
      label: "线下活动",
      list: [
        {
          id: "3-5",
          img: require("@/assets/image/activityList/banner3_5.png"),
          title: "EBC亮相智利Money Expo2025",
          subtitle:
            "全球最佳券商EBC 以最大赞助商身份，亮相智利Money Expo 2025，分享前沿知识、展示最新技术，助力拉美金融生态未来发展。",
          url: "",
          time: "2025年8月27-28日",
        },
        {
          id: "3-4",
          img: require("@/assets/image/activityList/banner3_4.jpg"),
          title: "EBC金融集团亮相2025拉美iFX EXPO",
          subtitle:
            "EBC作为钻石赞助商参加拉美iFX EXPO，展位为18号，分享如何在全球贸易格局重塑下，通过创新金融服务助力投资者把握机遇、规避风险。",
          url: "/LearningCenterInfo?id=LEARN-423-66C",
          time: "2025年4月9-10日",
        },
        {
          id: "3-3",
          img: require("@/assets/image/activityList/banner3_3.png"),
          title: "EBC亮相墨西哥Money Expo 2025",
          subtitle:
            "EBC作为铂金赞助商，亮相墨西哥Money Expo 2025！在这场墨西哥顶级的交易盛会中，共同探索金融科技新趋势，发现交易新机遇！",
          url: "/LearningCenterInfo?id=LEARN-782-60B",
          time: "2025年2月26-27日",
        },
        
      ],
    },
    {
      label: "交易大赛",
      list: [
        
        {
          id: "2-9",
          img: require("@/assets/image/activityList/banner2_9.png"),
          title: "EBC百万美金交易大赛Ⅱ完美收官",
          subtitle: "免费复制冠军收益",
          url: "/million-dollar-challenge-2",
          time: "",
        },
        {
          id: "2-1",
          img: require("@/assets/image/activityList/banner2_1.png"),
          title: "百万美金交易大赛",
          subtitle: "悬赏百万美金  寻找交易之王",
          url: "/win1",
          time: "",
        },
      ],
    },
    {
      label: "积分商城",
      list: [
        {
          id: "1-1",
          img: require("@/assets/image/activityList/banner1_1.png"),
          title: "EBC积分商城 认真对待每份期待",
          subtitle: "积分畅兑梦想豪车 、巴萨周边、热门单品",
          url: "https://client.myebc.co/signup-b",
          time: "",
          target: "_blank",
        },
      ],
    },
  ]
  let dropdownOptions = [
      { label: "全部", value: "all" },
      { label: "进行中", value: "processing" },
      { label: "待开始", value: "pending" },
      { label: "已结束", value: "ended" },
    ]
  let activityContentStatus = {
    processing: '火热进行中',
    pending: "待开始",
    ended: "已结束"
  }

  let headerContent = [{
    title:'赚取最高 <span class="red">18%</span> 年化管理费',
    desc:'管理资金量越大，年化收益越高',
    btn:'立即参与',
    bannerSrc:require("@/assets/image/activityList/activityListBanner1.png"),
    src:'/zh-cn/pay',
    ifTarget:false
  }]
export default {
    mixins: [fadeAnimate],
    data(){
        return {
        activityListTab: activityListMetaData.map(i => i.label),
        activityListMetaData,
        headerSwiper: null,
        activityListTabAct: 0,
        scrollTabAct: 0,
        isOpen: false,
        currentVal: "all",
        dropdownOptions,
        activityContentStatus,
        targetNavigationIndex: 1,
        headerContent
    }
    } 
    ,
    created() {
        console.log(activityListMetaData)
        this.setOldAcitivtyStatus()
    },
    mounted() {
        document.querySelectorAll('.mobilePagenation div')[0].classList.add('active')
        headerContent.length > 1 && this.initSwiper();
    },

    computed: {
        dataMeta() {
            const scrollTabActArr = ['', 'processing', 'pending', 'ended']
            const targetStatus = scrollTabActArr[this.scrollTabAct]
            return this.activityListMetaData[this.activityListTabAct].list.filter(i => i.status == targetStatus || !targetStatus)
        },
        // 动态计算当前显示的文字
        selectedLabel: function () {
            var target = this.dropdownOptions.find(
                function (opt) {
                    return opt.value === this.currentVal;
                }.bind(this)
            );
            return target ? target.label : "请选择";
        },
        pageNavigationNumber() {
            return Math.ceil(this.dataMeta.length / 8)
        },
        visiblePages() {
            const total = this.pageNavigationNumber
            const c = this.targetNavigationIndex
            if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1)
            if (c <= 3) return [1, 2, 3, 0, total]          // 0 代表 …
            if (c >= total - 2) return [1, 0, total - 2, total - 1, total]
            return [1, 0, c - 1, c, c + 1, 0, total]        // 7 项
        }
    },
    methods: {
        setOldAcitivtyStatus() {
            const activityStatus = {
                processing: ['2-12', '2-4', '2-3', '2-7', "2-2", "2-5", '1-1'],
                pending: [''],
                ended: ['2-6', '2-9', '2-8', "2-1", "3-5", "3-4", "3-3"]
            }
            const order = ["processing", "pending", "ended"];
            //旧活动状态补充
            this.activityListMetaData.forEach(i => {
                i.list.forEach(j => {
                    Object.keys(activityStatus).forEach(statusKey => {
                        activityStatus[statusKey].includes(j.id) && (j.status = statusKey)
                    })
                })
                i.list.sort((a, b) => {
                  const va = order.indexOf(a.status);
                  const vb = order.indexOf(b.status);
                  return va - vb;
                });
            })
        },
        jumpToActivity(item) {

            location.href = item.url
        },
        initSwiper() {
            this.headerSwiper = new Swiper(".activityModelSwiper", {
                loop: true,
                on: {
                    slideChange: function () {
                        document
                            .querySelectorAll(".activityHeadContent")
                            .forEach((item, index) => {
                                if (index == this.realIndex) {
                                    document
                                        .querySelector(".activityHeadContent.active")
                                        .classList.remove("active");
                                    item.classList.add("active");
                                    document
                                        .querySelector(".mobilePagenation .active")
                                        .classList.remove("active");
                                    document
                                        .querySelectorAll(".mobilePagenation div")
                                    [index].classList.add("active");
                                }
                            });
                    },
                },
            });
        },
        setTargetNavigationIndex(index) {
            if (index == 0) return
            this.targetNavigationIndex = index
        },
        shiftSwiper(index) {
            if (index == 1) {
                this.headerSwiper.slideNext();
                return;
            }
            this.headerSwiper.slidePrev();
        },
        changeTab(index, e) {
            this.activityListTabAct = index;
            this.currentVal = 'all';
            this.scrollTabAct = 0;
            this.initTabPosition(index, e, '.activityListTab');
        },
        initTabPosition(idx, e, domName) {
            const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const leftPad = 32 * rem;
            const wrapper = document.querySelector(domName);
            wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
        },
        initMobileTabWrapper(idx, item, e) {
            this.currentVal = item.value;
            this.scrollTabAct = idx;
            this.initTabPosition(idx, e, '.scrollTabWrapper');
        },
        // 切换下拉框显示隐藏
        toggleDropdown: function () {
            this.isOpen = !this.isOpen;
        },
        // 选中选项
        handleSelect(item, index) {
            this.currentVal = item.value;
            this.scrollTabAct = index;
            this.isOpen = false;
        },
        // 点击外部关闭下拉框
        handleClickOutside: function (e) {
            // this.$refs.dropdownRef 是 Vue 获取 DOM 的方式
            if (
                this.$refs.dropdownRef &&
                !this.$refs.dropdownRef.contains(e.target)
            ) {
                this.isOpen = false;
            }
        },

    },
}
</script>
<style>
.red{
  color:var(--ebc-basecolor-active-500);
}
</style>
<style lang="scss" scoped>
    .contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}
.red{
  color: var(--ebc-basecolor-active-500);
}
[v-cloak] {
    display: none !important;
}
a:hover {
  color: var(--ebc-text-primary_white);
}
.activityListHead {
  padding: 100rem 0 20rem;
  position: relative;
}
.activityHeadContent {
  flex: 0 0 676rem;
  display: none;
}
.activityHeadContent.active {
  display: block;
}
.activityHeadContentDesc {
  margin: 24rem 0 48rem;
  color: var(--ebc-text-secondary);
}
.activityModelSwiper {
  width: 500rem;
  height: 320rem;
}
.activityModel {
  width: 500rem;
  height: 320rem;
}
.activityHeadBtn {
  width: fit-content;
  min-width: 180rem;
  gap: 5rem;
}
.hoverPagenation {
  position: absolute;
  right: calc(50vw - 55rem);
  bottom: 50rem;
  gap: 32rem;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
  pointer-events: none;
}
.activityListHead:hover .hoverPagenation {
  opacity: 1;
  pointer-events: auto;
}
.hoverPagenation span {
  font-size: 22rem;
}
.hoverPagenation img {
  width: 24rem;
  height: 24rem;
}
.hoverPagenation > div {
  padding: 8rem;
  background: var(--ebc-neutral-bg_b);
  border-radius: var(--ebc-corner-radius-full);
}
.hoverPagenation .icon-right {
  transform: rotate(180deg);
}
.mobilePagenation {
  display: none;
}
 @media (min-width: 996px) {
   .activityListCard:hover .activityBtn{
      color: var(--ebc-basecolor-active-500);
    }
      .activityListCardImg {
        width:240rem;
        height: 160rem;
        border-radius: var(--ebc-corner-radius-rc08);
        overflow: hidden;
      }
      .activityListCard img{
        transition:transform 0.2s;
      }
      .activityListCard:hover img{
        transform: scale(1.1);
      }
    }
@media (max-width: 996px) {
  .mobilePagenation {
    display: none!important;
  }
   .activityStatus{
      padding: 8rem 16rem;
      border-radius: 4px;
      font-weight: 500!important;
    }
   .activityStatus svg{
    margin-right: 2px;
   }
  .contentBox {
    max-width: 100%;
    padding-inline: 32rem;
  }
  .activityListHead {
    padding: 32rem 0;
  }
  .activityListHead .contentBox {
    flex-direction: column;
  }
  .activityHeadContent {
    order: 2;
    flex: 1;
    text-align: center;
  }
  .hoverPagenation {
    display: none !important;
  }
  .mobilePagenation {
    display: flex;
    gap: 16rem;
  }
  .mobilePagenation div {
    width: 16px;
    height: 2px;
    border-radius: var(--ebc-corner-radius-full);
    background: rgba(0, 0, 0, 0.12);
  }
  .mobilePagenation div.active {
    width: 32px;
    background: var(--ebc-basecolor-active-500);
  }
  .activityModelSwiper {
    width: 100%;
    height: 560rem;
    padding: 32rem 0 48rem !important;
  }
  .activityModelSwiper img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
  .activityHeadContent {
    padding-top: 32rem;
  }
  .activityHeadContentDesc {
    margin-top: 16rem;
  }
  .activityListHead .activityHeadBtn {
    font-size: 28rem;
    height: 80rem;
    margin-inline: auto;
    // margin-bottom: 80rem;
  }
}
.activityListContainer {
  padding-bottom: 120rem;
}
.activityListTab {
  gap: 32rem;
}
.activityListTab div {
  padding: 4rem 0;
  color: var(--ebc-text-secondary);
}
.activityListTab div.active {
  position: relative;
  color: var(--ebc-basecolor-active-500);
  font-weight: 500;
}
.activityListTab div.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  width: 90%;
  height: 2px;
  background: var(--ebc-basecolor-active-500);
  transform: translateX(-50%);
  left: 50%;
}

/* 下拉框容器 */
.activity-dropdown-container {
  position: relative;
  display: inline-block;
  min-width: 102px;
  width: fit-content;
}

/* 触发按钮 */
.activity-dropdown-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 999px;
  cursor: pointer;
  font-size: 14rem;
  color: var(--ebc-text-secondary);
  transition: all 0.2s;
  user-select: none;
  height: 38px;
  gap: 4px;
}
.activity-dropdown-trigger span{
  line-height: 38px;
}
.activity-dropdown-trigger:hover {
  border-color: #bbb;
}

/* 激活状态 (注意这里也加了前缀) */
.activity-dropdown-trigger.activity-active .activity-arrow {
  transform: rotate(180deg);
}

/* 小箭头 */
.activity-arrow {
  font-size: 7px;
  color: var(--ebc-text-secondary);
  margin-left: 8px;
  transition: transform 0.3s;
}

/* 下拉菜单 */
.activity-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 8px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 1000;
  animation: activityFadeIn 0.2s ease-in-out;
}

/* 列表项 */
.activity-dropdown-item {
  padding: 12px 16px;
  font-size: 14rem;
  color: var(--ebc-text-secondary);
  cursor: pointer;
  transition: background 0.2s;
}

.activity-dropdown-item:hover {
  background-color: #f5f7fa;
  color: var(--ebc-text-primary);
}

/* 选中状态 */
.activity-dropdown-item.activity-selected {
  color: var(--ebc-text-primary);
  font-weight: 500;
}

@keyframes activityFadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
  .pageNavigation span{
      font-size: 24px;
      margin-left:8rem;
      padding:8px;
      background: var(--ebc-neutral-bg_b);
      border-radius: 50%;
      cursor: pointer;
    }
    .pageNavigation span.notAllow{
      pointer-events: none;
      color:var(--ebc-text-tertiary);
    }
     .pageNavigation span:nth-child(1){
      margin-right:8rem;
    }
    .pageNavigation{
      margin-top:60rem;
    }
    .pageNavigation div{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .pageNavigation .active{
      font-weight: 500;
      background: rgba(165, 41, 51, 0.10);
      color: var(--ebc-basecolor-active-500);
      border-radius: 50%;
    }
    .activityListData{
      display: flex;
      row-gap: 24rem;
      margin-top: 24rem;
    }
    .activityListCard{
      flex: 0 0 588rem;
      padding: 8rem;
      display: flex;
      gap: 8rem;
      background: var(--ebc-neutral-bg_b);
      border-radius: var(--ebc-corner-radius-rc08);
    }
    .activityListCard .activityListCardImg img{
      width:240rem;
      height: 160rem;
      border-radius: var(--ebc-corner-radius-rc08);
    }
    .activityContent{
      position: relative;
      padding: 8rem;
      flex:1
    }
     .activityContent .activityBtn{
      position: absolute;
      bottom: 8rem;
      right:8rem;
    }
    .activityStatus{
      padding: 4rem 8rem;
    //   line-height: 28rem;
      border-radius: var(--ebc-corner-radius-rc04);
      width: fit-content;
    }
    .activityStatus{
      margin-right: 2rem;
    }
    .activityTitle{
      margin-top: 12rem;
      display: -webkit-box;
      -webkit-line-clamp: 3; 
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .activityStatus.hot{
      color: var(--ebc-basecolor-active-500);
        background: linear-gradient(0deg, rgba(165, 41, 51, 0.10) 0%, rgba(165, 41, 51, 0.10) 100%), #FFF;
    }
    .activityStatus.wait{
      background: linear-gradient(0deg, rgba(204, 109, 0, 0.10) 0%, rgba(204, 109, 0, 0.10) 100%), #FFF;
      color: #CC6D00;
    }
    .activityStatus.end{
      background: rgba(0, 0, 0, 0.04);
      color: var(--ebc-text-tertiary);
    }
    .activityBtn{
      color: var(--ebc-text-tertiary);
      gap: 2rem;
    }
    .activityBtn .iconfont{
      font-size: 16rem;
    }
   
@media (max-width: 996px) {
  .activity-dropdown-container {
    display: none;
  }
  .activityListFilter {
    flex-direction: column;
  }
  .scrollTabWrapper {
    width: 100%;
    overflow-x: auto;
    scroll-behavior: smooth;
    margin-top: 48rem;
    background: var(--ebc-neutral-bg_a);
    position: sticky;
    top: 44px;
    z-index: 99;
    
  }
  .scrollTabWrapper::-webkit-scrollbar {
    display: none;
  }
  .scrollTab {
    gap: 24rem;
  }
  .scrollTab .tabItem {
    color: var(--ebc-text-secondary);
    padding: 0rem 24rem;
    height: 56rem;
    line-height: 56rem;
    background: var(--ebc-neutral-bg_b);
    border-radius: var(--ebc-corner-radius-full);
    white-space: nowrap;
  }
  .scrollTab .active {
    color: var(--ebc-basecolor-active-500);
    border:1px solid var(--ebc-basecolor-active-500);
    background: #fff;
  }
  .activityListContainer {
    padding: 96rem 0;
  }
  .activityListTab {
    gap: 48rem;
    max-width: 100%;
    width: 100%;
  }
  .activityListTab::-webkit-scrollbar {
    display: none;
  }
  .activityListTab div {
    padding-bottom: 12rem;
    white-space: nowrap;
  }
  .activityListTab div.active::after {
    bottom: 0;
  }
  .activityListTab {
    overflow: scroll;
  }
    .pageNavigation{
      margin-top:48rem;
    }
  .pageNavigation span:nth-child(1){
      margin-right:16rem;
    }

    .activityListData{
      margin-top: 48rem;
      flex-direction: column;
      gap: 48rem;
    }
    .activityListCard{
      width: 100%;
      border-radius: var(--ebc-corner-radius-rc16);
      overflow: hidden;
      padding: 0;
      flex-direction: column;
      flex: 1;
    }
    .activityListCard .activityListCardImg img{
      width: 100%;
      height: auto;
      aspect-ratio: 1.504;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    .activityContent{
      padding: 32rem 32rem 92rem;
      flex: 1;
    }
    .activityContent .activityBtn{
      right: 32rem;
      bottom: 32rem;
      gap: 8rem;
    }
    .activityBtn .iconfont{
      font-size: 32rem;
    }

}

</style>
